<template>
    <div class="modal flex w-full bg-white">
        <div class="modal_cover hidden lg:block lg:w-1/2">
            <img class="h-full w-full object-cover" src="img/auth/login_cover.jpg" alt="login_cover" />
        </div>
        <div class="modal_content_wrapper w-full lg:w-1/2 flex justify-center items-center  overflow-auto">
            <template>
                <slot></slot>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            window.addEventListener('click', function (e) {
                let este = e.target.closest('.btn-user') || e.target.closest('.modal')  || e.target.closest('.btn-my-account') || e.target.closest('#alert');
                if (!este) {
                    $eventbus.$emit('close:modal');
                }
            });
        },
        methods: {
            toggleAuthModal() {
                $eventbus.$emit('toggle:modal');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .modal {
        * {
            box-sizing: border-box;
        }
        top: 83px;
        position: absolute;
        min-height: calc(100vh - 83px);
        box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset;
        &_cover {
            height: calc(100vh - 83px);
            @media (max-height: 781px) {
                min-height: calc(100vh - 83px);
                height: unset;
            }
        }
        &_content_wrapper {
            height: 100%; 
            background-color: white;
            padding-inline: 1rem;
            overflow: auto;
            margin: auto;
            display:block;
            @media(min-width:768px){
                overflow: hidden;
                display:flex;
            }

            & > *{
                max-height: calc(100vh - 83px);
                overflow: auto;
            }
        }
    }
    .body-login {
        .modal {
            top: 0;
            min-height: unset;
            height: 100%;
            &_cover {
                height: 100%;
            }
        }
    }
</style>
